import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { ENABLED_DATA_PARTNERS_SECTION_ID } from '@openx/types/deal';
import { type ReactNode, useCallback } from 'react';
import { flashElementById } from '../utils/elementHighlight';

type DataPartnerFeesAlertProps = {
  message: ReactNode;
  /** Label of the button scrolling to the fees section; without it no button is rendered (e.g. on the package form). */
  actionLabel?: string;
  targetSectionId?: string;
  'data-test'?: string;
};

export const DataPartnerFeesAlert = ({
  message,
  actionLabel,
  targetSectionId = ENABLED_DATA_PARTNERS_SECTION_ID,
  'data-test': dataTest = 'data-partner-fees-warning',
}: DataPartnerFeesAlertProps) => {
  const onActionClick = useCallback(() => {
    flashElementById(targetSectionId);
  }, [targetSectionId]);

  return (
    <Alert severity="warning" sx={{ mt: 2 }} data-test={dataTest}>
      <Grid container>
        <Grid size={actionLabel ? 9 : 12}>
          <Typography>{message}</Typography>
        </Grid>

        {actionLabel ? (
          <Grid size={3}>
            <Button
              variant="text"
              color="warning"
              type="button"
              onClick={onActionClick}
              data-test="go-to-data-partner-fees"
            >
              {actionLabel}
            </Button>
          </Grid>
        ) : null}
      </Grid>
    </Alert>
  );
};
